import { getPlannedBudgetDateLabel } from "../../../../../utils/helpers/getPlannedBudgetDateLabel";
import { BudgetPeriod } from "@/services/cloudchipr.api";

interface GetPlannedBudgetsWithLabelsArgs {
  period: BudgetPeriod;
  plannedAmounts?: number[];
  startDate: string;
  quarterStartMonth?: number;
}

export const getPlannedBudgetsWithLabels = ({
  period,
  plannedAmounts,
  startDate,
  quarterStartMonth,
}: GetPlannedBudgetsWithLabelsArgs) => {
  if (!plannedAmounts) {
    return [];
  }

  return plannedAmounts.map((amount, index) => ({
    label: getPlannedBudgetDateLabel(
      period,
      startDate,
      index,
      quarterStartMonth,
    ),
    amount,
  }));
};
